export default __webpack_public_path__ + "static/media/logo-phone-top-up.6b54be9b.png";